<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">기간연장내역</span>
            <span class="txt">
                이용권 기간을 연장했던 내역을 확인합니다. 여러 이용권을 일괄연장 하고 싶은 경우 '기간연장 일괄등록'을
                클릭해주세요.
            </span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchCustomerStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        @keyup.enter="fetchExtendList"
                    />
                    <button class="search-btn">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['이용권명', ...prodTypeCodeList]"
                    :select-value="['', ...prodTypeCodeValueList]"
                    class="w220"
                    @update:set="(val) => (searchProdId = val.cp_center_prod_id)"
                ></select-form>
                <select-form
                    :select-data="['유형', ...expPlusTypeCodeList]"
                    :select-value="['', ...expPlusTypeCodeValueList]"
                    @update:set="(val) => (expirePlusType = val)"
                ></select-form>
                <select-form
                    :select-data="['상담자', ...expPlusStaffList]"
                    :select-value="['', ...expPlusStaffValueList]"
                    @update:set="(val) => (expirePlusStaffId = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>
        <p class="sub-title">회원목록</p>
        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ totalItems }}</span>
                        건
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <a
                        class="com-btn blue"
                        href="#"
                        @click="
                            checkAllowedClick('MB', 5, () => {
                                periodSignPop = true;
                            })
                        "
                    >
                        기간연장일괄등록
                    </a>
                </div>
            </div>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 110px" />
                    <col style="width: 340px" />
                    <col style="width: 200px" />
                    <col style="width: 225px" />
                    <col style="width: 225px" />
                    <col style="width: 100px" />
                    <col style="width: 100px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>회원명</th>
                        <th>이용권명</th>
                        <th>연장기간</th>
                        <th>변경 전 기간</th>
                        <th>변경 후 기간</th>
                        <th>상담자</th>
                        <th>유형</th>
                        <th>등록일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(e, index) in extendList" :key="index">
                        <td>
                            <router-link
                                :to="{
                                    path: `/madmin/member/info/${e.c_center_id}`,
                                    query: { customerId: e.c_center_cust_id },
                                }"
                                class="link"
                            >
                                {{ e.c_customer_nm }}
                            </router-link>
                        </td>
                        <td class="left">
                            <span
                                :class="{
                                    ico: true,
                                    'type-1': e.c_ticket_type_cd === 'P',
                                    'type-2': e.c_ticket_type_cd === 'G',
                                    'type-4': e.c_ticket_type_cd === 'T',
                                    'type-5': e.c_ticket_type_cd === 'D',
                                    'type-6': e.c_ticket_type_cd === 'O',
                                    'type-8': e.c_ticket_type_cd === 'S',
                                }"
                            >
                                {{ convertTicketTypeFormat(e.c_ticket_type_cd) }}
                            </span>
                            {{ e.c_prod_nm }}
                            <span>{{ getLessonCntString(e.c_less_cnt_type_cd, e.c_less_cnt) }}</span>
                        </td>
                        <td>
                            <span class="info-line">
                                {{ e.c_exp_plus_start_dt }} ~ {{ e.c_exp_plus_end_dt }}
                                <span>({{ e.c_exp_plus_day }}일)</span>
                            </span>
                        </td>
                        <td>
                            <template v-if="e.c_exp_start_dt !== null">
                                {{ e.c_org_exp_start_dt || (e.c_exp_start_dt === null) | timestampFilter }}
                            </template>
                            ~ {{ e.c_org_exp_end_dt | timestampFilter }}
                        </td>
                        <td>{{ e.c_exp_start_dt }} ~ {{ e.c_exp_end_dt }}</td>
                        <td>{{ e.c_staff_nm }}</td>
                        <td>{{ e.c_exp_plus_type_cd === 'N' ? '연기' : '홀딩' }}</td>
                        <td>{{ e.c_upd_dt | timestampFilter2 }}</td>
                    </tr>
                    <!--                    <tr>-->
                    <!--                        <td><a href="#" class="link">홍길동</a></td>-->
                    <!--                        <td class="left">-->
                    <!--                            <span class="ico type-6">[OT]</span>-->
                    <!--                            필라테스 10회-->
                    <!--                        </td>-->
                    <!--                        <td>-->
                    <!--                            <span class="info-line">-->
                    <!--                                <a href="#" class="link" @click="periodPop = true">2020-01-01 ~ 2020-01-31</a>-->
                    <!--                                <span>(5일)</span>-->
                    <!--                            </span>-->
                    <!--                        </td>-->
                    <!--                        <td>2019-05-01 ~ 2019-06-31</td>-->
                    <!--                        <td>2019-05-01 ~ 2019-07-05</td>-->
                    <!--                        <td>조인성</td>-->
                    <!--                        <td>연기</td>-->
                    <!--                        <td>2019-08-21<br>13:00:32</td>-->
                    <!--                    </tr>-->

                    <tr v-if="extendList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
        <!-- 기간연장 수정 팝업 -->
        <div v-if="periodPop && selectedExtendDetail" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="onClickClosePeriodPop"><span class="blind">팝업 닫기</span></button>
                <loading-spinner v-if="periodPopIsLoading"></loading-spinner>
                <div v-else class="scroll-area com-scroll-y">
                    <span class="sub-title">기간연장</span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 160px" />
                            <col style="width: 600px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>회원명</th>
                                <td>{{ selectedExtendDetail.c_customer_nm }}</td>
                            </tr>
                            <tr>
                                <th>이용권명</th>
                                <td>
                                    <span
                                        :class="{
                                            ico: true,
                                            'type-1': selectedExtendDetail.c_ticket_type_cd === 'P',
                                            'type-2': selectedExtendDetail.c_ticket_type_cd === 'G',
                                            'type-7': selectedExtendDetail.c_ticket_type_cd === 'C',
                                            'type-4': selectedExtendDetail.c_ticket_type_cd === 'T',
                                            'type-5': selectedExtendDetail.c_ticket_type_cd === 'D',
                                            'type-6': selectedExtendDetail.c_ticket_type_cd === 'O',
                                            'type-8': selectedExtendDetail.c_ticket_type_cd === 'S',
                                        }"
                                    >
                                        {{ convertTicketTypeFormat(selectedExtendDetail.c_ticket_type_cd) }}
                                    </span>
                                    {{ selectedExtendDetail.c_prod_nm }}
                                    {{
                                        getLessonCntString(
                                            selectedExtendDetail.c_less_cnt_type_cd,
                                            selectedExtendDetail.c_less_cnt
                                        )
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <th>현재 유효기간</th>
                                <td>
                                    <template v-if="selectedExtendDetail.c_exp_start_dt">
                                        {{ selectedExtendDetail.c_exp_start_dt }}
                                    </template>
                                    ~
                                    <template v-if="selectedExtendDetail.c_exp_end_dt">
                                        {{ selectedExtendDetail.c_exp_end_dt }}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th>유형</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-1"
                                                v-model="editField.expirePlusType"
                                                name="radio-pop"
                                                type="radio"
                                                value="N"
                                            />
                                            <label for="radio-pop-1">연기 (단순 기간 연기)</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-2"
                                                v-model="editField.expirePlusType"
                                                name="radio-pop"
                                                type="radio"
                                                value="H"
                                            />
                                            <label for="radio-pop-2">홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                                        </div>
                                    </div>
                                    <span class="red">
                                        <span class="imp">*</span>
                                        홀딩 기간 중 예약은 자동 취소 됩니다.
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    연장기간
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="line">
                                        <single-calendar
                                            :disabled="true"
                                            :start-date="editField.expirePlusStartDt"
                                            @update="updateExpStartDt"
                                        ></single-calendar>
                                        <div class="com-dash"><span class="dash">~</span></div>
                                        <single-calendar
                                            :end-date="editField.expirePlusEndDt"
                                            @update="updateExpEndDt"
                                        ></single-calendar>
                                    </div>
                                    <div class="line">
                                        <input
                                            class="center w60"
                                            type="text"
                                            v-bind:value="editField.expirePlusDay"
                                            @keypress="isNumber($event)"
                                            v-on:keyup="onInputExpPlusDay($event)"
                                        />
                                        <span class="txt">일</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>변경 후 유효기간</th>
                                <td>
                                    <span class="red">
                                        {{ selectedExtendDetail.c_exp_start_dt }} ~ {{ calExpEndDt }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    등록자
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <select-form
                                        :select-data="['선택', ...expPlusStaffList]"
                                        :select-value="['', ...expPlusStaffValueList]"
                                        :selected-value="editField.expirePlusStaffId"
                                        class="w160"
                                        @update:set="(val) => (editField.expirePlusStaffId = val)"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th>연기 사유</th>
                                <td>
                                    <textarea v-model="editField.expirePlusMemo" class="full"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn red" @click="onClickDeleteExtendDetail">삭제</button>
                        <button class="com-btn" @click="onClickClosePeriodPop">취소</button>
                        <button class="com-btn blue" @click="onClickModifyExtendDetail">수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 기간연장 등록 팝업 -->
        <div v-show="periodSignPop" class="layer-pop square-type">
            <div class="view-content w700">
                <button class="close" @click="onClickCloseBundleExtend($event)">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">기간연장 일괄등록</span>
                    <p class="sub-txt">이용권별로 선택하여 해당 이용권을 가진 유효회원의 기간을 일괄연장 합니다.</p>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 135px" />
                            <col style="width: 465px" />
                        </colgroup>
                        <loading-spinner v-if="bundleExtendIsloading"></loading-spinner>
                        <tbody v-else>
                            <tr>
                                <th>이용권명</th>
                                <td>
                                    <select-check-form
                                        :select-data="['전체', ...prodTypeCodeList]"
                                        :select-value="['all', ...prodTypeCodeValueList]"
                                        :selected-value="bundleExtendProdId"
                                        class="w350"
                                        title="이용권명"
                                        @update:set="(val) => (bundleExtendProdId = val)"
                                    ></select-check-form>
                                    <!-- <select-check-form title="이용권명" :select-data="[...prodTypeCodeList]" :select-value="[...prodTypeCodeValueList]" @update:set="val => bundleExtendProdId = val" class="w350" :selected-value="bundleExtendProdId"></select-check-form> -->
                                </td>
                            </tr>
                            <tr>
                                <th>유형</th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-2-1"
                                                v-model="bundleExtendEditField.expirePlusType"
                                                name="radio-pop-2"
                                                type="radio"
                                                value="N"
                                            />
                                            <label for="radio-pop-2-1">연기 (단순 기간 연기)</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-2-2"
                                                v-model="bundleExtendEditField.expirePlusType"
                                                name="radio-pop-2"
                                                type="radio"
                                                value="H"
                                            />
                                            <label for="radio-pop-2-2">홀딩 (연장 기간동안 예약 및 입장 불가)</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>연장기간</th>
                                <td>
                                    <div class="flex">
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :start-date="bundleExtendEditField.expirePlusStartDt"
                                                class="w150"
                                                @update="updateBundleExtendStartDt"
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="bundleExtendEditField.expirePlusEndDt"
                                                class="w150"
                                                @update="updateBundleExtendEndDt"
                                            ></single-calendar>
                                        </div>
                                        <input
                                            v-model="bundleExtendEditField.expirePlusDay"
                                            class="center w30 ml5"
                                            disabled
                                            type="text"
                                        />
                                        <span class="txt">일</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>등록자</th>
                                <td>
                                    <select-form
                                        :select-data="['상담자', ...expPlusStaffList]"
                                        :select-value="['', ...expPlusStaffValueList]"
                                        :selected-value="bundleExtendEditField.expirePlusStaffId"
                                        class="w160"
                                        @update:set="(val) => (bundleExtendEditField.expirePlusStaffId = val)"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr>
                                <th class="vat">연기 사유</th>
                                <td>
                                    <textarea v-model="bundleExtendEditField.expirePlusMemo" class="full"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClickCloseBundleExtend($event)">취소</button>
                        <button class="com-btn blue" @click="onClickSaveBundleExtend">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import moment from 'moment';
import EventBus from '@/assets/js/eventBus';
import XLSX from 'xlsx';
import { timestampToDate } from '@/assets/js/excelCommon.js';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'memberAttend',
    mixins: [MixinAllowedMenu],
    components: { LoadingSpinner },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        searchProdId(newValue) {
            // 이용권명
            this.searchProdId = newValue;
            this.fetchExtendList();
        },
        expirePlusType(newValue) {
            // 유형
            this.expirePlusType = newValue;
            this.fetchExtendList();
        },
        expirePlusStaffId(newValue) {
            // 상담자
            this.expirePlusStaffId = newValue;
            this.fetchExtendList();
        },
    },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        today() {
            return moment().format('YYYY-MM-DD');
        },
        calExpEndDt() {
            // 변경 후 유효기간 종료일 계산
            return moment(this.selectedExtendDetail.c_exp_end_dt)
                .add(this.editField.expirePlusDay, 'days')
                .format('YYYY-MM-DD');
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    mounted() {
        this.centerId = parseInt(this.cId);
        this.bundleExtendEditField.expirePlusStaffId = parseInt(this.staffId, 10); // 기간연장 일괄등록 팝업에서 현재 로그인한 staffId 로 기본 선택
        this.bundleExtendEditField.expirePlusStartDt = this.today; // 기간연장 일괄등록 팝업에서 시작일은 오늘로 고정
        this.bundleExtendEditField.expirePlusEndDt = this.today;
        this.bundleExtendEditField.expirePlusDay = 1;
        this.init();
    },
    data() {
        return {
            isLoading: false,
            periodPopIsLoading: false,
            bundleExtendIsloading: false,
            periodPop: false,
            periodSignPop: false,

            centerId: '',
            centerInfo: {},
            extendList: [],
            totalItems: '',
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            centerProdInfo: [], // 센터 상품 목록 (이용권, 패키지)
            prodTypeCodeList: [], // 이용권명 이름 목록
            prodTypeCodeValueList: [], // 이용권명 값(id) 목록
            expPlusTypeCodeList: ['연기', '홀딩'], // 유형 이름 목록
            expPlusTypeCodeValueList: ['N', 'H'], // 유형 값 목록
            expPlusStaffList: [], // 상담자 이름 목록
            expPlusStaffValueList: [], // 상담자 값(id) 목록

            startDate: '', // 검색 파라미터 (시작일)
            endDate: '', // 검색 파라미터 (종료일)
            searchCustomerStr: '', // 검색 파라미터 (이름, 연락처)
            searchPeriod: '', // 검색 기간
            searchProdId: '', // 검색 파라미터 (이용권명)
            expirePlusType: '', // 검색 파라미터 (유형)
            expirePlusStaffId: '', // 검색 파라미터 (상담자)

            pagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            selectedExtendDetail: {}, // 팝업에 보여질 선택한 연장기간 상세

            editField: {
                expirePlusType: 'N',
                expirePlusStartDt: '',
                expirePlusEndDt: '',
                expirePlusDay: '',
                expirePlusStaffId: '',
                expirePlusMemo: '',
            },
            bundleExtendEditField: {
                expirePlusType: 'N',
                expirePlusStartDt: null,
                expirePlusEndDt: null,
                expirePlusDay: '',
                expirePlusStaffId: '',
                expirePlusMemo: '',
            },
            bundleExtendProdId: '', // 기간연장 일괄등록 팝업에서 선택한 이용권 Id

            count: 1,
        };
    },
    methods: {
        // 초기화
        init() {
            this.isLoading = true;
            this.initStartDate(); // 검색 시작일 초기화
            this.initEndDate(); // 검색 시작일 초기화
            Promise.allSettled([
                this.fetchExtendList(),
                this.fetchCenterProdList(),
                this.fetchCenterStaffList(),
                this.getCenterInfo(),
            ]);
            // 기간연장 내역 목록 가져오기
            // 이용권 목록 가져오기
            // 상담자 목록 가져오기
            // centerId 로 센터 정보 가져오기
            this.isLoading = false;
        },

        // 엑셀 다운로드
        async excelDownload() {
            const { data } = await this.sendGetExtendListForExcelDownload();

            const excelDownloadArray = [];
            data.items.forEach((extend) => {
                const temp = {};
                temp['회원명'] = extend.c_customer_nm;
                temp['이용권명'] = extend.c_prod_nm;
                temp['연장기간'] = `${timestampToDate(extend.c_org_exp_end_dt)}~${timestampToDate(
                    extend.c_exp_plus_end_dt
                )}(${extend.c_exp_plus_day}일)`;
                temp['변경 전 기간'] = `${timestampToDate(extend.c_org_exp_start_dt)}~${timestampToDate(
                    extend.c_org_exp_end_dt
                )}`;
                temp['변경 후 기간'] = `${timestampToDate(extend.c_exp_plus_start_dt)}~${timestampToDate(
                    extend.c_exp_plus_end_dt
                )}`;
                temp['상담자'] = extend.c_staff_nm;
                temp['유형'] = extend.c_exp_plus_type_cd === 'N' ? '연기' : '홀딩';
                temp['등록일'] = timestampToDate(extend.c_cre_dt);
                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 15 },
                { wch: 28 },
                { wch: 25 },
                { wch: 25 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
            ];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '기간연장내역');
            XLSX.writeFile(wb, `기간연장내역 ${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        // 기간연장 내역 목록 가져오기
        async fetchExtendList() {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetExtendList();
                this.setPageParams(data);
                this.extendList = data.items;
                this.totalItems = data.meta.totalItems;
                this.extendList.forEach((extend) => {
                    if (extend.c_exp_start_dt !== null) {
                        extend.c_exp_start_dt = timestampToDate(extend.c_exp_start_dt);
                    }
                    if (extend.c_exp_end_dt !== null) {
                        extend.c_exp_end_dt = timestampToDate(extend.c_exp_end_dt);
                    }
                    if (extend.c_exp_plus_start_dt !== null) {
                        extend.c_exp_plus_start_dt = timestampToDate(extend.c_exp_plus_start_dt);
                    }
                    if (extend.c_exp_plus_end_dt !== null) {
                        extend.c_exp_plus_end_dt = timestampToDate(extend.c_exp_plus_end_dt);
                    }
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                alert('기간연장내역을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        sendGetExtendList() {
            const { startDate, endDate, searchCustomerStr, searchProdId, expirePlusType, expirePlusStaffId } = this;
            const searchParams = {
                searchStr: searchCustomerStr,
                startDate,
                endDate,
                searchCustomerStr,
                centerProductId: searchProdId,
                expirePlusType,
                expirePlusStaffId,
            };
            // 스웨거 검색: 센터회원 기간연장내역 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/contract/extend`, {
                params: {
                    ...this.pagingInfo,
                    ...searchParams,
                },
            });
        },

        // 기간연장 내역 목록 조회 API 호출 (엑셀 다운로드시에만 사용)
        sendGetExtendListForExcelDownload() {
            const { startDate, endDate, searchCustomerStr, searchProdId, expirePlusType, expirePlusStaffId } = this;
            const searchParams = {
                searchStr: searchCustomerStr,
                startDate,
                endDate,
                searchCustomerStr,
                centerProductId: searchProdId,
                expirePlusType,
                expirePlusStaffId,
            };
            return api.get(`/admin/api/center/${this.centerId}/contract/extend`, {
                params: {
                    page: 1,
                    limit: 10000,
                    ...searchParams,
                },
            });
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 센터 상품 목록 fetch
        async fetchCenterProdList() {
            try {
                const { data } = await this.sendGetCenterProdList();
                this.centerProdInfo = data.items;
                this.arrangeProdInfo(this.centerProdInfo); // 받아온 이용권 목록을 변수에 셋팅
            } catch (error) {
                alert('이용권 목록을 불러오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 상품 목록 조회 API
        sendGetCenterProdList() {
            return api.get(`/admin/api/center/${this.centerId}/product/ticket`, {
                params: {
                    page: 1,
                    limit: 99999,
                },
            });
        },

        // 받아온 센터 상품 목록으로 select-form에 나타내기 위해 정리
        arrangeProdInfo(data) {
            // 상품 유형 코드(productType) - T : 이용권(Ticket),  P : 패키지(Package), L : 락커, C : 트레이닝복, S : 부가상품(Sub Product)
            // 이용권_유형_코드(ticketType) - P : 개인,  O : OT,  D : 듀엣,  G : 그룹,  C : 쿠폰,  T : 회원권
            // 수업_횟수_유형_코드(lessonCountType) - T : 총횟수(Total),  W : 주당횟수(Week),  U : 무제한(Unlimit)
            //
            // '[이용권구분] 이용권명' 또는
            // '[패키지] 패키지명' 으로 불러온다.
            //
            //  노출 순서는
            // [이용권 구분] 회원권>개인>OT>듀엣>그룹>쿠폰>패키지 순이다.
            // 이용권 구분 후 이용권명 ㄱㄴㄷ 순이다.

            data.forEach((prod) => {
                const tempType = ['', '', ''];
                const { cp_center_prod_id, cp_center_prod_ver, cp_namee, cp_less_cnt } = prod;
                const tempTypeValue = {
                    cp_center_prod_id,
                    cp_center_prod_ver,
                };

                switch (
                    prod.cp_prod_type_cd // 상품 유형 case
                ) {
                    case 'T': // 이용권
                        switch (
                            prod.cp_ticket_type_cd // 이용권 유형 case
                        ) {
                            case 'P': // 개인
                                tempType[0] = '[개인]';
                                break;
                            case 'O': // OT
                                tempType[0] = '[OT]';
                                break;
                            case 'D': // 듀엣
                                tempType[0] = '[듀엣]';
                                break;
                            case 'G': // 그룹
                                tempType[0] = '[그룹]';
                                break;
                            case 'C': // 쿠폰
                                tempType[0] = '[쿠폰]';
                                break;
                            case 'T': // 회원권
                                tempType[0] = '[회원권]';
                                break;
                            case 'S': // 운동복
                                tempType[0] = '[운동복]';
                                break;
                        }
                        break;
                    case 'P': // 패키지
                        tempType[0] = '[패키지]';
                        tempType[2] = '';
                        break;
                }

                switch (
                    prod.cp_less_cnt_type_cd // 수업 횟수 유형 case
                ) {
                    case 'T': // 총횟수(Total)
                        tempType[2] = `${cp_less_cnt}회`;
                        break;
                    case 'W': // 주당횟수(Week)
                        tempType[2] = `주${cp_less_cnt}회`;
                        break;
                    case 'U': // 무제한(Unlimit)
                        tempType[2] = '';
                        break;
                    default:
                        tempType[2] = '';
                        break;
                }

                tempType[1] = cp_namee; // 이용권 이름
                this.prodTypeCodeList.push(`${tempType[0]} ${tempType[1]} ${tempType[2]}`);
                this.prodTypeCodeValueList.push(tempTypeValue);
            });
        },

        // 이용권 유형 코드 변환
        getTicketTypeString(ticketType) {
            let str = '';
            switch (ticketType) {
                case 'P': // 개인
                    str = '[개인]';
                    break;
                case 'O': // OT
                    str = '[OT]';
                    break;
                case 'D': // 듀엣
                    str = '[듀엣]';
                    break;
                case 'G': // 그룹
                    str = '[그룹]';
                    break;
                case 'C': // 쿠폰
                    str = '[쿠폰]';
                    break;
                case 'T': // 회원권
                    str = '[회원권]';
                    break;
                case 'S': // 운동복
                    str = '[운동복]';
                    break;
            }
            return str;
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchExtendList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchExtendList();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.initStartDate();
            this.initEndDate();
            this.searchCustomerStr = '';
            this.searchPeriod = '';
            this.searchProdId = '';
            this.expirePlusType = '';
            this.expirePlusStaffId = '';
            this.fetchExtendList();
            EventBus.$emit('event:initList', 'init');
        },

        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '[운동복]';
            }
        },

        // 직원(상담자) 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                data.forEach((d) => {
                    this.expPlusStaffList.push(d.name);
                    this.expPlusStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchExtendList();
        },

        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchExtendList();
        },

        // 연장기간 링크 클릭시
        onClickExtendDetail(index) {
            this.periodPop = true;
            this.selectedExtendDetail = this.extendList[index];

            const ef = {
                expirePlusType: this.selectedExtendDetail.c_exp_plus_type_cd,
                expirePlusStartDt: this.selectedExtendDetail.c_exp_start_dt,
                expirePlusEndDt: this.selectedExtendDetail.c_exp_end_dt,
                expirePlusDay: '',
                expirePlusStaffId: this.selectedExtendDetail.c_exp_plus_staff_id,
                expirePlusMemo: this.selectedExtendDetail.c_exp_plus_memo,
            };
            this.editField = ef;
        },

        // 팝업 닫기 버튼 클릭시
        onClickClosePeriodPop() {
            this.periodPop = false;
            this.selectedExtendDetail = {};
        },

        // 유효기간 연장 기간 시작일 변경시
        updateExpStartDt(val) {
            // const checkAfterStartDt = moment(val).isSameOrAfter(this.selectedExtendDetail.c_exp_start_dt, 'day'); // 현재 유효기간 시작일 이후인지 체크
            // const checkBeforeEndDt = moment(val).isSameOrBefore(this.selectedExtendDetail.c_exp_end_dt, 'day'); // 현재 유효기간 종료일 이전인지 체크
            //
            // if(val !== this.today && (checkAfterStartDt === false || checkBeforeEndDt === false)) {
            //     alert('현재 유효기간 내에서 선택하세요.');
            //     return;
            // }
        },

        // 유효기간 연장 기간 종료일 변경시
        updateExpEndDt(val) {
            // let plusEndDt = moment(val, 'YYYY-MM-DD');
            // const checkAfterStartDt = moment(val).isSameOrAfter(this.selectedExtendDetail.c_exp_start_dt, 'day'); // 현재 유효기간 시작일 이후인지 체크
            // const checkBeforeEndDt = moment(val).isSameOrBefore(this.selectedExtendDetail.c_exp_end_dt, 'day'); // 현재 유효기간 종료일 이전인지 체크
            //
            // if(checkAfterStartDt === false || checkBeforeEndDt === false) {
            //     alert('현재 유효기간 내에서 선택하세요.');
            //     return;
            // }

            if (val === '' || val === undefined) {
                return;
            }

            // 시작일보다 이전날짜 인지 체크
            const checkAfterExpStartDt = moment(val).isSameOrAfter(this.editField.expirePlusStartDt, 'day');
            if (checkAfterExpStartDt === false) {
                alert('연장 시작일보다 이전 날짜입니다. 다시 선택하세요.');
            }

            const curExpEndDt = moment(val, 'YYYY-MM-DD'); // 변경한 연장기간 종료일
            const curExpStartDt = moment(this.selectedExtendDetail.c_exp_end_dt).startOf('day'); // 현재 유효기간 종료일
            const diffDays = moment.duration(curExpEndDt.diff(curExpStartDt)).asDays(); // 현재 유효기간 종료일 ~ 연장하는 유효기간 종료일 차이를 구함
            this.editField.expirePlusEndDt = val;
            this.editField.expirePlusDay = diffDays;
        },

        // 연장 일수 입력시
        onInputExpPlusDay(event) {
            this.editField.expirePlusEndDt = moment(this.editField.expirePlusStartDt)
                .add(event.target.value, 'days')
                .format('YYYY-MM-DD');
        },

        // timestampTZ -> date (년-월-일)
        timestampFilter(value) {
            const b = value.split(/\D/);
            --b[1];
            b[6] = b[6].substr(0, 3);
            const d = new Date(Date.UTC(...b));
            return `${d.getFullYear()}-${this.addZero(d.getMonth() + 1)}-${this.addZero(d.getDate())}`;
        },

        addZero(target) {
            // 9 이하의 숫자는 0 붙이기
            const num = parseInt(target);
            const str = num > 9 ? num : `0${num}`;
            return str.toString();
        },

        // 기간연장 수정 팝업에서 수정 버튼 클릭시
        async onClickModifyExtendDetail() {
            try {
                this.periodPopIsLoading = true;
                await this.sendPutExtendDetail();
                alert('기간연장이 수정 되었습니다.');
                this.periodPopIsLoading = false;
                this.periodPop = false;
                await this.fetchExtendList();
            } catch (error) {
                this.periodPopIsLoading = false;
                alert('기간연장 수정 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원 기간연장내역 저장/수정 API 호출
        sendPutExtendDetail() {
            const params = this.getModifyParams();
            return api.put(
                `/admin/api/center/${this.centerId}/contract/extend/${this.selectedExtendDetail.c_center_contract_id}`,
                {
                    ...params,
                }
            );
        },

        // 기간연장 수정 파라미터 가공
        getModifyParams() {
            const {
                expirePlusType,
                expirePlusStartDt,
                expirePlusEndDt,
                expirePlusDay,
                expirePlusStaffId,
                expirePlusMemo,
            } = this.editField;

            const params = {
                expirePlusType,
                expirePlusStartDt,
                expirePlusEndDt,
                expirePlusDay,
                expirePlusStaffId,
                expirePlusMemo,
            };

            return params;
        },

        // 기간연장 수정 팝업에서 삭제 버튼 클릭시
        async onClickDeleteExtendDetail() {
            try {
                this.periodPopIsLoading = true;
                await this.sendDeleteExtendDetail();
                alert('기간연장이 삭제 되었습니다.');
                this.periodPopIsLoading = false;
                this.periodPop = false;
            } catch (error) {
                this.periodPopIsLoading = false;
                alert('기간연장 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원 기간연장내역 삭제 API 호출
        sendDeleteExtendDetail() {
            return api.delete(
                `/admin/api/center/${this.centerId}/contract/extend/${this.selectedExtendDetail.c_center_contract_id}`
            );
        },

        // 숫자만 입력 감지
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 기간연장 일괄등록 팝업에서 연장기간 시작일 변경시
        updateBundleExtendStartDt(val) {
            this.bundleExtendEditField.expirePlusStartDt = val;
            if (this.bundleExtendEditField.expirePlusEndDt !== null) {
                // 종료일이 선택되어 있으면
                const checkBeforeEndDt = moment(val).isSameOrBefore(this.bundleExtendEditField.expirePlusEndDt, 'day'); // 선택된 종료일 이전인지 체크
                if (checkBeforeEndDt === false) {
                    alert('종료일보다 이후 날짜입니다. 다시 선택하세요.');
                    this.bundleExtendEditField.expirePlusDay = 0;
                }

                const selectStartDt = moment(val, 'YYYY-MM-DD'); // 변경한 연장기간 시작일
                const selectEndDt = moment(this.bundleExtendEditField.expirePlusEndDt).startOf('day'); // 연장기간 종료일
                const diffDays = moment.duration(selectEndDt.diff(selectStartDt)).asDays(); // 연장기간 시작일~종료일 일수 계산
                if (diffDays < 0) {
                    alert('날짜를 다시 선택하세요.');
                    this.bundleExtendEditField.expirePlusDay = 0;
                } else {
                    this.bundleExtendEditField.expirePlusDay = diffDays + 1;
                }
            }
        },

        // 기간연장 일괄등록 팝업에서 연장기간 종료일 변경시
        updateBundleExtendEndDt(val) {
            if (val === '' || val === undefined || val === null) {
                return;
            }

            const checkAfterStartDt = moment(val).isSameOrAfter(this.bundleExtendEditField.expirePlusStartDt, 'day'); // 선택된 시작일 이후인지 체크

            if (checkAfterStartDt === false) {
                this.bundleExtendEditField.expirePlusDay = 0;
                this.bundleExtendEditField.expirePlusEndDt = '';
                alert('시작일보다 이전 날짜입니다. 다시 선택하세요.');
            } else {
                const selectEndDt = moment(val, 'YYYY-MM-DD'); // 변경한 연장기간 종료일
                const selectStartDt = moment(this.bundleExtendEditField.expirePlusStartDt).startOf('day'); // 연장기간 시작일
                const diffDays = moment.duration(selectEndDt.diff(selectStartDt)).asDays(); // 연장기간 시작일~종료일 일수 계산
                if (diffDays < 0) {
                    alert('다시 선택하세요.');
                    this.bundleExtendEditField.expirePlusDay = 0;
                } else {
                    this.bundleExtendEditField.expirePlusDay = diffDays + 1;
                    this.bundleExtendEditField.expirePlusEndDt = val;
                }
            }
        },

        // 기간연장 일괄등록 팝업에서 저장버튼 클릭시
        async onClickSaveBundleExtend() {
            console.log('선택 체크박스내용', this.bundleExtendProdId);
            try {
                const validate = this.validateValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return;
                }

                this.bundleExtendIsloading = true;
                await this.sendPutBundleExtend();
                alert('기간연장 일괄등록 되었습니다.');
                this.bundleExtendIsloading = false;
                this.periodSignPop = false;
                this.bundleExtendEditField = {
                    // 기간연장 일괄등록 변수 초기화
                    expirePlusType: '-',
                    expirePlusStartDt: this.today,
                    expirePlusEndDt: null,
                    expirePlusDay: '',
                    expirePlusStaffId: parseInt(this.staffId),
                    expirePlusMemo: '',
                };
                this.bundleExtendProdId = []; // 기간연장 일괄등록 팝업에서 선택한 이용권 Id 초기화
                await this.fetchExtendList();
            } catch (error) {
                this.bundleExtendIsloading = false;

                if (error.response) {
                  alert(error.response.data.message)
                } else {
                  alert('기간연장 일괄등록 중 오류가 발생했습니다.');
                }
            }
        },

        // 센터상품 기간연장 일괄등록
        sendPutBundleExtend() {
            let temp = '';

            this.bundleExtendProdId.map((element, index) => {
                if (element !== 'all') {
                    temp += `${element.cp_center_prod_id},`;
                }
            });

            if (temp[temp.length - 1] === ',') {
                temp = temp.slice(0, -1);
            }

            const {
                expirePlusType,
                expirePlusStartDt,
                expirePlusEndDt,
                expirePlusDay,
                expirePlusStaffId,
                expirePlusMemo,
            } = this.bundleExtendEditField;
            const params = {
                expirePlusType,
                expirePlusStartDt,
                expirePlusEndDt,
                expirePlusDay,
                expirePlusStaffId,
                expirePlusMemo,
            };
            return api.put(`/admin/api/center/${this.cId}/contract/extend/center-product/${temp}`, {
                ...params,
            });
        },

        // 기간연장 일괄등록 필수값 체크
        validateValues() {
            // 필수값 체크
            let result = false;
            const { bundleExtendEditField, bundleExtendProdId } = this;
            let msg = '';

            if (bundleExtendProdId.length === 0) {
                msg = '이용권을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (bundleExtendEditField.expirePlusType === '-') {
                msg = '유형을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (bundleExtendEditField.expirePlusEndDt === null || bundleExtendEditField.expirePlusStartDt === null) {
                msg = '연장기간을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (bundleExtendEditField.expirePlusStartDt === '' || bundleExtendEditField.expirePlusEndDt === '') {
                msg = '연장기간을 다시 확인하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (bundleExtendEditField.expirePlusStaffId === '') {
                msg = '등록자를 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            result = true;
            return { result };
        },

        // 기간연장 일괄등록 팝업에서 취소 버튼 클릭시
        onClickCloseBundleExtend(e) {
            e.preventDefault();
            this.periodSignPop = false;
            this.bundleExtendEditField = {
                // 기간연장 일괄등록 변수 초기화
                expirePlusType: '-',
                expirePlusStartDt: this.today,
                expirePlusEndDt: this.today,
                expirePlusDay: 1,
                expirePlusStaffId: parseInt(this.staffId),
                expirePlusMemo: '',
            };
            this.bundleExtendProdId = ''; // 기간연장 일괄등록 팝업에서 선택한 이용권 Id 초기화
        },

        // 수업 횟수 유형 변환
        getLessonCntString(lessonCountType, lessonCount) {
            let str = '';
            switch (lessonCountType) {
                case 'T': // 총횟수
                    str = `${lessonCount}회`;
                    break;
                case 'W': // 주당횟수
                    str = `주 ${lessonCount}회`;
                    break;
                case 'U': // 무제한
                    str = '';
                    break;
            }
            return str;
        },
    },
};
</script>
<style lang="scss"></style>
